import * as React from 'react';
const EmptyWrapper = ({ children, emptyRender, isRefetching }) => {
    var _a;
    return !isRefetching ? React.createElement(React.Fragment, null, ((_a = React.Children.toArray(children)) === null || _a === void 0 ? void 0 : _a.length) > 0 ? children : emptyRender()) : null;
};
export default EmptyWrapper;
